import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { AlertCircleIcon, SparklesIcon } from 'lucide-react';
import { episodeChapters } from '../data/abbviePro';
import { AbbVieHeroPlayer } from './AbbVieHeroPlayer';
import { SkyRiziProductMockup } from './SkyRiziProductMockup';
export function HookScreen() {
  const reduceMotion = useReducedMotion();
  return <section className="flex min-h-screen items-center bg-white px-6 py-20" aria-labelledby="hook-title" data-id="element-225" data-mp="6e03zpc5ju37">
      <div className="mx-auto w-full max-w-7xl" data-id="element-226" data-mp="bctjtoewvx6j">
        <div className="mx-auto mb-14 max-w-4xl text-center" data-id="element-227" data-mp="beo6p89qtzd9">
          <p className="mb-4 text-sm font-semibold text-primary" data-id="element-228" data-mp="3slq7jttaop9s">02 - Bring the portal to life</p>
          <h2 id="hook-title" className="text-4xl font-bold leading-tight text-secondary md:text-6xl" data-id="element-229" data-mp="1edsbkbz2lwi">
            From a wall of content to a hero worth watching
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-slate-500" data-id="element-230" data-mp="1vsy6de5sfj6x">
            The first 10 seconds decide whether an HCP stays. Here's the same SKYRIZI moment, snackified.
          </p>
        </div>

        <div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:items-center" data-id="element-231" data-mp="3itewsuraga6a">
          <motion.div initial={reduceMotion ? false : {
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col" data-id="element-232" data-mp="3iraugh91fj84">
            <div className="mb-4 flex items-center gap-2 text-sm font-semibold text-rose-700" data-id="element-233" data-mp="34v75b2d0u12i">
              <AlertCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-234" data-mp="2zwdszd9h0g3x" />
              Today: everything, all at once
            </div>
            <div className="overflow-hidden rounded-2xl border border-rose-200 bg-white opacity-90 shadow-md" data-id="element-235" data-mp="39rxkzokwyune">
              <SkyRiziProductMockup variant="landing" className="rounded-none border-0 shadow-none" data-id="element-236" data-mp="t31ta2ptwjmj" />
            </div>
            <p className="mt-4 text-sm leading-relaxed text-slate-500" data-id="element-237" data-mp="p1gay1uizd4y">Every pathway is visible at once - the user must decide where to begin before any value is proven.</p>
          </motion.div>

          <motion.div initial={reduceMotion ? false : {
          opacity: 0,
          x: 16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col" data-id="element-238" data-mp="3muhyyyqje1ng">
            <div className="mb-4 flex items-center gap-2 text-sm font-semibold text-abbvie-pro" data-id="element-239" data-mp="2z7s0g7decp7l">
              <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-240" data-mp="345ticoz36ihh" />
              Tomorrow: one story, on demand
            </div>
            <AbbVieHeroPlayer chapters={episodeChapters} videoSrc="https://cdn.magicpatterns.com/uploads/39NZfd1nkd211NXMHgdtEj/video-1787566550880.mp4" data-id="element-241" data-mp="3852c3tu4mgd1" />
            <p className="mt-4 text-sm leading-relaxed text-slate-500" data-id="element-242" data-mp="2geo0635obe40">Press play - the same information, delivered as a snackable, episodic hero embed.</p>
          </motion.div>
        </div>
      </div>
    </section>;
}